import { render, staticRenderFns } from "./accountActivate.vue?vue&type=template&id=1c772782&"
import script from "./accountActivate.js?vue&type=script&defer=true&lang=js&"
export * from "./accountActivate.js?vue&type=script&defer=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports